const getErrorMessage = (error) => {
    // default message
    const DEFAULT_MESSAGE = 'Đã xảy ra lỗi. Vui lòng thử lại.'

    if (!error) return DEFAULT_MESSAGE

    // Axios error with response
    if (error.response) {
        const status = error.response.status

        if (status === 414 || status === 431) {
            return 'Bạn đang chọn quá nhiều giá trị trong bộ lọc. Vui lòng giảm bớt và thử lại.'
        }

        return (
            error.response.data && error.response.data.message ? error.response.data.message : error.message ? error.message : DEFAULT_MESSAGE
        )
    }

    // Network Error (browser blocked request)
    if (error.message === 'Network Error') {
        return 'Bạn đang chọn quá nhiều giá trị trong bộ lọc. Vui lòng giảm bớt và thử lại.'
    }

    return error.message || DEFAULT_MESSAGE
}

export default getErrorMessage